import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "@websential/cosmic-v20";

import { IDropDownListResponse } from "../models/common/IDropDownListResponse";
import { IGetListRequest } from "../models";
import { ISalaryProfileListModel } from "../models";
import { ISalaryProfileRequestPayload } from "../models";
import { ITD1Form } from "../models/TD1Federal/IFederal";
import { format422Errors } from "../common/Common";
import http from "../common/http-commons";

export const CompanyTD1FormService = {
  getDataTD1EmployeeDetailById: async (
    id: string | undefined,
  ): Promise<ITD1Form | IServerError | IResponse | null | any> => {
    console.log("qwertyuiop[");
    if (!id) {
      return null;
    }
    try {
      const response: AxiosResponse<ITD1Form> = await http.get<ITD1Form>(
        `/v1/employee-td1-form/${id}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        // navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getDataEmployeeTD1Form: async (
    // navigateToLogout: (path: string) => void,
    date: string,
    provinceId: string,
    employeeId: string,
    clientId: string,
  ): Promise<ITD1Form | IServerError | IResponse | null | any> => {
    try {
      const response: AxiosResponse<ITD1Form> = await http.get<ITD1Form>(
        `/v1/employee-td1-form/?effective_date=${date}&province_id=${provinceId}&employee_id=${employeeId}&client_id=${clientId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        // navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getDataByProvinceAndCurrentDate: async (
    navigateToLogout: (path: string) => void,
    date: string | null,
    provinceId: string,
  ): Promise<ITD1Form | IServerError | IResponse | null | any> => {
    if (!provinceId) return null;
    if (!date) return null;
    try {
      const response: AxiosResponse<ITD1Form> = await http.get<ITD1Form>(
        // `/v1/td1-form/?effective_date=${date}&province_id=${provinceId}`
        `/v1/employee-td1-form/td1_form?effective_date=${date}&province_id=${provinceId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      if (response.status === 404) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 404) {
        return axiosError.response;
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  getDataEmployeeTD1FormDDL: async (
    employeeId: string,
    provinceId: string,
  ): Promise<ITD1Form | IServerError | IResponse | null | any> => {
    if (!employeeId) {
      return null;
    }

    try {
      const response: AxiosResponse<ITD1Form> = await http.get<ITD1Form>(
        `/v1/employee-td1-form/ddl?employee_id=${employeeId}&province_id=${provinceId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        // navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  // getDataEmployeeTD1FormDDL: async (
  // 	date: string | null,
  // 	provinceId: string
  // ): Promise<IServerError | IResponse | null | any> => {

  // 	try {
  // 		const response: AxiosResponse<ITD1Form> = await http.get<ITD1Form>(
  // 			`/v1/employee-td1-form/td1_form?effective_date=${date}&province_id=${provinceId}`
  // 		);

  // 		if (response.status === 200) {
  // 			return response.data;
  // 		} else if (response.status === 500) {
  // 			return {
  // 				status: false,
  // 				message: "Something went wrong.",
  // 				error: true,
  // 			};
  // 		}

  // 		return {
  // 			status: false,
  // 			message: "Something went wrong please try again later.",
  // 		};
  // 	} catch (error) {
  // 		const axiosError = error as AxiosError;
  // 		console.error("An error occurred:", axiosError);
  // 		const errorMessage =
  // 			axiosError.response && typeof axiosError.response.data === "string"
  // 				? axiosError.response.data
  // 				: "Unknown error";
  // 		if (axiosError && axiosError.status === 401) {
  // 			// navigateToLogout("/logout");
  // 			return {
  // 				status: false,
  // 				message: "UnAuthrized",
  // 			};
  // 		} else {
  // 			return {
  // 				status: false,
  // 				message: errorMessage,
  // 			};
  // 		}
  // 	}
  // },

  createTD1EmployeeForm: async (
    requestPayload: any,
  ): Promise<any | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<any> = await http.put<any>(
          `/v1/employee-td1-form/${requestPayload.id}/`,
          requestPayload,
        );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        }
        if (response.status === 404) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else if (axiosError && axiosError.status === 422) {
          return {
            status: false,
            message: `Errors : \n${format422Errors(
              axiosError?.response?.data,
            )}`,
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<any> = await http.post<any>(
        `/v1/employee-td1-form/`,
        requestPayload,
      );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else if (axiosError && axiosError.status === 422) {
        return {
          status: false,
          message: `Errors : \n${format422Errors(axiosError?.response?.data)}`,
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  //////////////// ///////////////// //////////////// ///////////////////// //////////////////

  getSalaryProfileById: async (
    id: string | undefined,
    clientId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse | null> => {
    if (id) {
      try {
        const response: AxiosResponse<any> = await http.get<any>(
          `/v1/salary-profile/${id}/`,
        );
        if (response.status === 200) {
          return response.data;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        return {
          status: false,
          message: errorMessage,
        };
      }
    }

    return null;
  },
  getResourceSalaryProfileDropDownList: async (
    resourceId: string,
    clientId: string,
    taxYear: number,
  ): Promise<IDropDownListResponse[] | IServerError | IResponse> => {
    const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
      IDropDownListResponse[]
    >(
      `/v1/salary-profile/ddl-salary-profile/${resourceId}?client_id=${clientId}&tax_year=${taxYear}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  deleteTD1FormById: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    const response: AxiosResponse<string> = await http.delete<string>(
      `/v1/employee-td1-form/${requestPayload.id}/`,
    );

    if (response.status === 200) {
      return "Success";
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    } else if (response.status === 400) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  delBulkSlips: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    const response = await http.delete<string>(
      `/v1/t4-slips/bulk-delete/${requestPayload.clientId}/?tax_year=${requestPayload.taxYear}`,
      { data: requestPayload.ids },
    );
    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getList: async (
    clientId: string,
    taxYear: number,
    params: IGetListRequest,
  ): Promise<ISalaryProfileListModel[] | IServerError | IResponse> => {
    const response: AxiosResponse<ISalaryProfileListModel[]> = await http.get<
      ISalaryProfileListModel[]
    >(
      `/v1/t4-slips/?client_id=${clientId}&tax_year=${taxYear}&order_by=${params.order_by}&order_direction=${params.order_direction}&page=${params.page}&size=${params.size}&search_query=${params.search_query}`,
    );

    if (response.status === 200) {
      return response.data;
    } else if (response.status === 500) {
      return {
        status: false,
        message: "Something went wrong.",
        error: true,
      };
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getEmployeeDDL: async (
    clientId: string,
    taxYear?: number,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
      IDropDownListResponse[]
    >(`/v1/employees/ddl?client_id=${clientId}`);

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getEmployeeDDLByStatus: async (
    clientId: string,
    status: number,
    taxYear?: number,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
      IDropDownListResponse[]
    >(
      `/v1/employees-status/employee-status-ddl?client_id=${clientId}&emplooyee_status=${status}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getEmployeeDDLByStatusAndByProvince: async (
    clientId: string,
    provinceId: string,
    taxYear: number,
    status: number,
  ): Promise<any | IServerError | IResponse | null> => {
    if (!provinceId) return null;
    const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
      IDropDownListResponse[]
    >(
      `/v1/dashboard/employee/${provinceId}/on-province-base?client_id=${clientId}&tax_year=${taxYear}&status_code=${status}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  getSalaryProfileDDL: async (
    clientId: string,
    employeeId: string,
    taxYear?: number,
  ): Promise<any | IServerError | IResponse | null> => {
    if (employeeId) {
      const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
        IDropDownListResponse[]
      >(`/v1/salary-profile/salary-profile-ddl?employee_id=${employeeId}`);

      if (response.status === 200) {
        return response.data;
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } else {
      return null;
    }
  },
  getProfileAppliesFromPayPeriodDDL: async (
    clientId: string,
    employeePayPeriodId: string,
    taxYear?: number,
  ): Promise<any | IServerError | IResponse | null> => {
    if (employeePayPeriodId) {
      try {
        const response: AxiosResponse<IDropDownListResponse[]> = await http.get<
          IDropDownListResponse[]
        >(
          `/v1/payroll-schedule/ddl/pay_period_dates?client_id=${clientId}&payroll_schedule_id=${employeePayPeriodId}&tax_year=${taxYear}`,
        );

        if (response.status === 200) {
          return response.data;
        }

        return {
          status: false,
          message: "Something went wrong please try again later.",
        };
      } catch {}
    }
    return null;
  },
  getEmployeeInformationById: async (
    resourceId: string | undefined,
  ): Promise<any | IServerError | IResponse | null> => {
    if (resourceId) {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/employees/${resourceId}/`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    }

    return null;
  },
  getEDREarningsAndTimeFormatData: async (
    clientId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse | null> => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/salary-profile/salary-profile-edr?client_id=${clientId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      return {
        status: false,
        message: errorMessage,
      };
    }
  },
};
